module.exports = __webpack_public_path__ + "media/images/odysseyFirmware-2a09f724.png";